import { Component, OnInit, OnDestroy } from '@angular/core';
import { GroupModel } from '@app/core/models/groups/group.model';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { MultiSelectModel } from '@app/shared/models/multi-select.model';
import { takeUntil } from 'rxjs/operators';
import { RecipientEntityModel } from '@app/core/models/recipient-entity/recipient-entity.model';
import { RecipientEntitiesService } from '@app/core/services/recipient-entities.service';
import { GroupTypeModel } from '@app/core/models/groups/group-type.model';
import { MatDialog } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { GroupService } from '@app/core/services/group.service';
import { AdministrationDetailBase } from '../../administration-detail-base';
import * as _ from 'lodash';

@Component({
  selector: 'app-recipient-entity-detail',
  templateUrl: './recipient-entity-detail.component.html',
  styleUrls: ['./recipient-entity-detail.component.scss']
})
export class RecipientEntityDetailComponent extends AdministrationDetailBase implements OnInit, OnDestroy {

  recipientEntity: RecipientEntityModel;

  operationalGroups: GroupModel[] = [];
  consultationGroups: GroupModel[] = [];
  supervisionGroups: GroupModel[] = [];

  selectedItemsOperationalGroups: GroupModel[] = [];
  selectedItemsObservationGroups: GroupModel[] = [];
  selectedItemsSupervisionGroups: GroupModel[] = [];

  singleSelectionDropDownSettings: IDropdownSettings;
  isCreateMode: boolean;

  constructor(
    groupService: GroupService,
    private route: ActivatedRoute,
    private router: Router,
    private multiSelectModel: MultiSelectModel,
    private recipientEntitiesService: RecipientEntitiesService,
    public dialog: MatDialog) {
    super(groupService);
    this.recipientEntity = new RecipientEntityModel();
    this.recipientEntity.SupervisionGroups = [];
  }

  ngOnInit(): void {
    this.singleSelectionDropDownSettings = this.multiSelectModel.getSettings('Id', 'Name', true, true, true, false);
    this.singleSelectionDropDownSettings.allowRemoteDataSearch = true;

    this.route.params
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: Params) => this.isCreateMode = _.isNil(data.id));

    this.route.data
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(resolverData => {
        this.resolveRecipientEntity(resolverData.recipientEntity);

        if (!_.isNil(resolverData.recipientEntity.OperationalGroupId)) {
          this.selectedItemsOperationalGroups = [new GroupModel(resolverData.recipientEntity.OperationalGroupId, resolverData.recipientEntity.OperationalGroupName)];
        }

        if (!_.isNil(resolverData.recipientEntity.ObservationGroupId)) {
          this.selectedItemsObservationGroups = [new GroupModel(resolverData.recipientEntity.ObservationGroupId, resolverData.recipientEntity.ObservationGroupName)];
        }
      });
  }

  protected onGroupFetched(groupType: GroupTypeModel, groups: GroupModel[]) {
    switch (groupType) {
      case GroupTypeModel.OPERATIONAL:
        this.operationalGroups = groups;
        break;
      case GroupTypeModel.SUPERVISION:
        this.supervisionGroups = groups;
        break;
      case GroupTypeModel.OBSERVATION:
        this.consultationGroups = groups;
        break;
    }
  }

  resolveRecipientEntity(recipientEntity: RecipientEntityModel): void {
    if (_.isNil(recipientEntity)) {
      return;
    }

    this.recipientEntity = recipientEntity;

    if (_.isNil(this.recipientEntity.SupervisionGroups)) {
      this.recipientEntity.SupervisionGroups = [];
    }

    this.selectedItemsSupervisionGroups = [_.head(this.recipientEntity.SupervisionGroups)];
  }

  onSelectSupervisionGroup(data: any, action: string): void {
    switch (action) {
      case 'select':
        this.recipientEntity.SupervisionGroups = [data];
        break;
      case 'deselect':
        this.recipientEntity.SupervisionGroups = [];
        break;
    }
  }

  onSelectOperationalGroup(data: any, action: string): void {
    switch (action) {
      case 'select':
        this.recipientEntity.OperationalGroupId = data.Id;
        break;
      case 'deselect':
        this.recipientEntity.OperationalGroupId = null;
        break;
    }
  }

  onSelectObservationGroup(data: any, action: string): void {
    switch (action) {
      case 'select':
        this.recipientEntity.ObservationGroupId = data.Id;
        break;
      case 'deselect':
        this.recipientEntity.ObservationGroupId = null;
        break;
    }
  }

  resetAll(): void {
    this.recipientEntity = new RecipientEntityModel();
    this.selectedItemsOperationalGroups = [];
    this.selectedItemsObservationGroups = [];
    this.selectedItemsSupervisionGroups = [];
  }

  onSave(): void {
    if (this.isCreateMode) {
      this.recipientEntitiesService.createRecipientEntity(this.recipientEntity)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(_ => {
          this.navigateToRecipientEntitiesList();
        });
    } else {
      this.recipientEntitiesService.updateRecipientEntity(this.recipientEntity)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(_ => {
          this.navigateToRecipientEntitiesList();
        });
    }
  }

  onCancel() {
    this.navigateToRecipientEntitiesList();
  }

  onGroupFilterChange(groupType: GroupTypeModel, data: string) {
    this.groupSearchEvent$.next([groupType, data]);
  }

  private navigateToRecipientEntitiesList(): void {
    this.router.navigate(['administration/recipient-entities'])
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }
}
